import React, { useState } from 'react';
import { InstagramIcon, MenuIcon, XIcon } from 'lucide-react';
import { brand } from '../data/brand';
import { AnnouncementBar } from './AnnouncementBar';
const navItems = [{
  label: 'Collections',
  href: '#collections'
}, {
  label: 'Best Sellers',
  href: '#best-sellers'
}, {
  label: 'About Us',
  href: '#founder'
}, {
  label: 'FAQ',
  href: '#faq'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  return <header className="sticky top-0 z-40 w-full" data-id="element-121" data-mp="2wkqmk4t2c68q">
      <AnnouncementBar data-id="element-122" data-mp="2wj5oi57ji564" />

      <div className="border-b border-line bg-white" data-id="element-123" data-mp="31bywr327vvmy">
        <div className="relative mx-auto max-w-editorial px-5 md:px-12 lg:px-20" data-id="element-124" data-mp="31cgxabvwww0o">
          <div className="flex items-center justify-between py-3" data-id="element-125" data-mp="36a0f1lrtjqxd">
            <button type="button" onClick={() => setMenuOpen(open => !open)} aria-expanded={menuOpen} aria-label={menuOpen ? 'Close menu' : 'Open menu'} className="-ml-2 flex h-9 w-9 items-center justify-center text-maroon md:hidden" data-id="element-126" data-mp="3baemb1lliwuc">
              {menuOpen ? <XIcon className="h-5 w-5" strokeWidth={1.4} data-id="element-127" data-mp="2rk6qbtvuic57" /> : <MenuIcon className="h-5 w-5" strokeWidth={1.4} data-id="element-128" data-mp="2mng7iysnp2g3" />}
            </button>

            <div className="ml-auto flex items-center" data-id="element-129" data-mp="2hovgnpzanv4b">
              <a href={brand.instagramHref} target="_blank" rel="noreferrer" aria-label={`Instagram ${brand.instagram}`} className="-mr-2 flex h-9 items-center gap-2 px-2 text-maroon transition-colors duration-150 ease-luxe hover:text-gold-deep" data-id="element-130" data-mp="3fb2l8zvllngo">
                <InstagramIcon className="h-[18px] w-[18px]" strokeWidth={1.4} data-id="element-131" data-mp="30lo95k0n0rxl" />
                <span className="hidden font-sans text-[10px] tracking-[0.14em] sm:inline" data-id="element-132" data-mp="1xhf5xo3h1yl">
                  {brand.instagram}
                </span>
              </a>
            </div>
          </div>

          <nav aria-label="Primary" className="hidden pb-5 pt-1 md:block" data-id="element-133" data-mp="1remd8h4frwf4">
            <ul className="flex items-center justify-center gap-10 lg:gap-14" data-id="element-134" data-mp="1wceei1qz0uvz">
              {navItems.map(item => <li key={item.href} data-id="element-135" data-mp="1hmqfx8a6caby">
                  <a href={item.href} className="whitespace-nowrap font-sans text-[11px] uppercase tracking-luxe text-maroon transition-colors duration-150 ease-luxe hover:text-gold-deep focus-visible:text-gold-deep focus-visible:outline-none" data-id="element-136" data-mp="1hlnpt2koebx3">
                    {item.label}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>

        {menuOpen && <nav aria-label="Mobile" className="border-t border-line bg-white px-5 py-4 md:hidden" data-id="element-137" data-mp="13p1sptsmwr3q">
            <ul className="flex flex-col" data-id="element-138" data-mp="2t0u6s5lgtics">
              {navItems.map(item => <li key={item.href} className="border-b border-line-soft last:border-b-0" data-id="element-139" data-mp="2y1hzcvpce794">
                  <a href={item.href} onClick={() => setMenuOpen(false)} className="block py-3.5 text-center font-sans text-[12px] uppercase tracking-luxe text-maroon" data-id="element-140" data-mp="mf69yo308y4f">
                    {item.label}
                  </a>
                </li>)}
            </ul>
          </nav>}
      </div>
    </header>;
}